(()=> {
  const logos = [
    document.querySelector('.rk-mobile-pill__logo'),
    document.querySelector('.rk-mobile-hero__spin-logo'),
  ].filter(Boolean);

  if (!logos.length) return;

  let last = window.scrollY || 0;
  let rotation = 0;

  window.addEventListener('scroll', () => {
    const now = window.scrollY || 0;
    rotation += (now - last) * 0.35;
    logos.forEach(logo => { logo.style.transform = `rotate(${rotation}deg)`; });
    last = now;
  }, { passive: true });
})();